import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class CentresService {
  private apiUrl = `${this.SharedProperties.baseUrlService()}/MOE/services/centres`;

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $http: angular.IHttpService,
    private $rootScope: angular.IRootScopeService
  ) { }

  getCentres(paramsMapes: any): angular.IPromise<any> {
    const _params = { ...paramsMapes };
    return this.$http
      .post(`${this.apiUrl}/find?`, _params)
      .then((response: any) => ({
        centres: response.data.centres,
        registresTotal: response.data.registresTotal
      }))
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error al carregar els centres", "error");
        this.$rootScope.$broadcast("error");
      });
  }

  getNomCentresAhead(paramsMapes: any): angular.IPromise<any[]> {
    const _params = { ...paramsMapes };
    return this.$http
      .post(`${this.apiUrl}/findTypeahead?`, _params)
      .then((response: any) => response.data.centres)
      .catch((error) => console.error(error));
  }

  getCentresAdscrits(codiCentre: string): angular.IPromise<any[]> {
    const config = { params: { codiCentre } };
    return this.$http
      .get(`${this.apiUrl}/findAdscrits`, config)
      .then((response: any) => response.data.centres)
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
      });
  }

  getCentresAdscritsPare(codiCentre: string): angular.IPromise<any[]> {
    const config = { params: { codiCentre } };
    return this.$http
      .get(`${this.apiUrl}/findAdscritsPare`, config)
      .then((response: any) => response.data.centres)
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
      });
  }

  getCentresAdscritsSE(codiSE: string): angular.IPromise<any[]> {
    const config = { params: { codiSE } };
    return this.$http
      .get(`${this.apiUrl}/findCentresSE`, config)
      .then((response: any) => response.data.centres)
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
      });
  }

  exportarCentres(paramsExcel: any): angular.IPromise<void> {
    return this.exportExcel(`${this.apiUrl}/exportCentres?`, paramsExcel);
  }

  exportarCentresPreinscripcio(paramsExcel: any): angular.IPromise<void> {
    return this.exportExcel(`${this.apiUrl}/preinscripcio/exportCentres?`, paramsExcel);
  }

  private exportExcel(url: string, paramsExcel: any): angular.IPromise<void> {
    return this.$http
      .post(url, paramsExcel, { responseType: "arraybuffer" })
      .then((response: any) => {
        const isIE = !!(document as any).documentMode;
        const blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
        if (isIE && (window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveOrOpenBlob(blob, "Exportacio_IE.xls");
        } else {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Exportacio.xls";
          document.body?.appendChild(link);
          link.click();
        }
      });
  }
}

angularJsApp.service(AppServicesEnum.CENTRES_SERVICE, CentresService);